module.exports = __webpack_public_path__ + "img/q4-11.afd2510f.png";